import { ThemeProvider } from '@emotion/react';
import MainRouter from './components/navigation/Routes';
import { HelmetProvider } from 'react-helmet-async';

import theme from './styles/theme';

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <ThemeProvider theme={theme}>
                    <MainRouter />
                </ThemeProvider>
            </div>
        </HelmetProvider>
    );
}

export default App;